import apiClient from '@/services/axios'

export async function post() {
  var response = await apiClient.post('/venues/import')
  if (response) {
    return response.data
  }

  throw new Error('Unable to import IDM venues.')
}
